module.exports = __webpack_public_path__ + "img/seat_manage.034f81f4.png";